export class SystemLocation {
    subSystemName: string;
    location: string;
    responsibility: string;
    systemType: string;
}
